<template>
  <div class="main-container" :class="{ 'has-header': showHeader, 'has-footer': showFooter }">
    <div class="main-header">
      <slot name="main-header">
        <h1 class="title">{{title}}</h1>
        <slot name="sub-title"><h3 class="sub-title">{{subTitle}}</h3></slot>
      </slot>
    </div>
    <div class="main-content">
      <slot name="main-content"></slot>
    </div>
    <div class="main-footer">
      <slot name="main-footer"></slot>
    </div>
  </div>
</template>

<script>

export default {
  name: 'MainContainerCmp',
  props: {
    title: '',
    subTitle: null,
    showHeader: {type: Boolean, default: true},
    showFooter: {type: Boolean, default: true}
  }
}

</script>

<style lang="scss" scoped>
  $--side-navi-width: 180px;
  $--body-min-width: 1240px;
  $--body-min-height: 640px;
  $--main-header-height: 80px;
  $--main-footer-height: 80px;

  .main-container {
    display: flex;
    flex-direction: column;
    background-color: #fff;
    flex-grow: 1;
    min-width: calc(#{$--body-min-width} - #{$--side-navi-width});
    max-width: calc(100vw - #{$--side-navi-width});
    min-height: 100vh;
  }

  .main-container > .main-header,
  .main-container > .main-footer {
    display: none;
  }

  .main-container.has-header > .main-header,
  .main-container > .main-content,
  .main-container.has-footer > .main-footer {
    display: flex;
    flex-direction: row;
  }

  .main-container.has-header > .main-header {
    flex-shrink: 0;
    align-items: center;
    height: $--main-header-height;
    border-bottom: 1px solid #c0d5ef;
  }

  .main-container > .main-content {
    flex-grow: 1;
    overflow-y: auto;
    max-width: inherit;
    max-height: 100vh;
    min-height: $--body-min-height;
  }

  .main-container.has-header > .main-content {
    max-height: calc(100vh - #{$--main-header-height});
    min-height: calc(#{$--body-min-height} - #{$--main-footer-height});
  }

  .main-container.has-footer > .main-content {
    max-height: calc(100vh - #{$--main-header-height});
    min-height: calc(#{$--body-min-height} - #{$--main-footer-height});
  }

  .main-container.has-header.has-footer > .main-content {
    max-height: calc(100vh - #{$--main-header-height} - #{$--main-footer-height});
    min-height: calc(#{$--body-min-height} - #{$--main-header-height} - #{$--main-footer-height});
  }

  .main-container.has-footer > .main-footer {
    flex-shrink: 0;
    align-items: stretch;
    justify-content: left;
    height: $--main-footer-height;
    border-top: 1px solid #c0d5ef;
    padding: 15px 24px;
  }

  .main-container.has-header > .main-header .title {
    font-size: 1.8rem;
    font-weight: normal;
    flex-shrink: 0;
    margin-left: 24px;
    margin-right: 24px;
  }

  .main-container.has-header > .main-header .sub-title {
    font-size: 1.5rem;
    font-weight: normal;
    color: #6ba7ef;
    margin-left: 20px;
  }

  .main-container > .main-content > * {
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  .main-footer button {
    flex-grow: 1;
    min-width: 200px;
    max-width: 320px;
    margin-left: 0;
  }

  .main-footer button:not(:last-child) {
    margin-right: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/main-container.vue